"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useBudPayPayment;

var _configValidation = require("./configValidation");

var _closePayWithBudPayModal = _interopRequireWildcard(require("./closePayWithBudPayModal"));

var _assetsFunctions = require("./assetsFunctions");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function useBudPayPayment(config) {
  var iFrameValidateAndReturnDataInput = function iFrameValidateAndReturnDataInput() {
    if (!config) {
      console.log('Error!. Please check our documentation for correct configurations.');
      return {
        status: false
      };
    }

    if ((0, _configValidation.VerifyRequiredDataInConfig)(config) === false) {
      console.log('Set required field (Amount, Key, Email) data in the config');
      return {
        status: false
      };
    }

    var verifyDataIfValid = (0, _configValidation.VerifyApiKeyData)(config.api_key) && (0, _configValidation.VerifyAmountData)(config.amount) && (0, _configValidation.ValidateEmailAddress)(config.email);

    if (!verifyDataIfValid) {
      console.log('Check that you entered correct data in the config');
      return {
        status: false
      };
    }

    return {
      status: true,
      type: 'initializeTransaction',
      key: config.api_key || null,
      email: config.email || null,
      amount: config.amount || null,
      currency: config.currency || null,
      first_name: config.first_name || null,
      last_name: config.last_name || null,
      phone: config.phone || null,
      logo_url: config.logo_url || null,
      callback_url: config.callback_url || null,
      reference: config.reference || '' + Math.floor(Math.random() * 1000000000 + 1) + new Date().getSeconds() + new Date().getMilliseconds()
    };
  }; // Create Payment Modal iFrame Function


  var createPaymentModalIFrame = function createPaymentModalIFrame() {
    var iframeDiv = document.createElement("iframe");
    iframeDiv.setAttribute("id", "budpay-iframe-container");
    iframeDiv.setAttribute("style", "position:fixed;top:0;left:0;z-index:99999999999999;border:none;opacity:0;pointer-events:none;width:100%;height:100%;");
    iframeDiv.setAttribute("allowTransparency", "true");
    iframeDiv.setAttribute("width", "100%");
    iframeDiv.setAttribute("height", "100%");
    iframeDiv.setAttribute("allow", "clipboard-read; clipboard-write");
    iframeDiv.setAttribute('src', 'https://inlinepay.budpay.com'); // iframeDiv.setAttribute('src', 'http://127.0.0.1:5500');

    return iframeDiv;
  }; // load iframe to website body and send config data


  var loadIframeToWebsiteBody = function loadIframeToWebsiteBody() {
    if (!iFrameValidateAndReturnDataInput().status) {
      alert('Error. Could not load Payment Modal. Please check console for more details.');
      console.log('Could not load Payment Modal. Error. Please try Again');
      return false;
    }

    document.body.appendChild((0, _assetsFunctions.OpenSVGLoaderFuncBudPay)()); // Append SVG Loader

    document.body.appendChild(createPaymentModalIFrame()); // Append Iframe

    document.querySelector('iframe#budpay-iframe-container').onload = function () {
      (0, _assetsFunctions.RemoveSVGLoaderFuncBudPay)(); // Remove SVG Loader

      var iframeSelector = document.querySelector('iframe#budpay-iframe-container');
      iframeSelector.style.opacity = "1";
      iframeSelector.style.pointerEvents = "auto";
      iframeSelector.contentWindow.postMessage(iFrameValidateAndReturnDataInput(), "*"); // Send Data to Child Iframe
    };
  }; // Listen to events from iframe


  if (typeof window !== "undefined") {
    window.addEventListener('message', function (event) {
      if (!event.data) {
        return;
      }

      function safeJsonParse(str) {
        try {
          return [null, JSON.parse(str)];
        } catch (err) {
          return [err];
        }
      }

      var _safeJsonParse = safeJsonParse(event.data),
          _safeJsonParse2 = _slicedToArray(_safeJsonParse, 2),
          err = _safeJsonParse2[0],
          result = _safeJsonParse2[1];

      if (!err) {
        if (result.type === 'closeTransaction') {
          (0, _closePayWithBudPayModal.closePaymentTransactionCallback)(result, config);
        }

        if (result.type === 'cancelPayment') {
          (0, _closePayWithBudPayModal["default"])('internalCall', result, config);
        }
      }
    });
  }

  return loadIframeToWebsiteBody;
}